import { __extends } from "tslib";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
import { ReportFilterOperationType } from "peekdata-datagateway-api-sdk";
import React from "react";
import { CustomDatePicker } from "../../CustomDatePicker";
import { DropDownList } from "../../DropDownList";
import { DropDownListWithSearch } from "../../DropDownListWithSearch";
import { FilterOptionTypes, FilterTypes, IFilter, } from "../../../models/filter";
import { IDimension } from "../../../models/node";
import { ITranslations } from "../../../models/translations";
import { IChangeFilterInput, ISelectFilter, } from "../../../state/actions";
import "../../../../style/components/filterControl.scss";
var FilterControl = (function (_super) {
    __extends(FilterControl, _super);
    function FilterControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFilterTypeOptions = function () {
            var t = _this.props.t;
            return new Map([
                [FilterTypes.DateRanges, t.filterTypeDateRange],
                [FilterTypes.SingleKeys, t.filterTypeSingleKey],
                [FilterTypes.SingleValues, t.filterTypeSingleValue],
            ]);
        };
        _this.onTypeSelected = function (selectedItem) {
            var _a = _this.props, filter = _a.filter, onFilterOptionSelected = _a.onFilterOptionSelected;
            onFilterOptionSelected({
                filter: filter,
                selectedItem: selectedItem,
                optionType: FilterOptionTypes.FilterType,
            });
        };
        _this.onFilterRemoveClicked = function () {
            var _a = _this.props, filter = _a.filter, onFilterRemoveClicked = _a.onFilterRemoveClicked, onGenerateReportRequest = _a.onGenerateReportRequest;
            onFilterRemoveClicked(filter);
            if (filter && filter.filterType) {
                onGenerateReportRequest();
            }
        };
        _this.getSingleKeyOperationOptions = function () {
            var t = _this.props.t;
            return new Map([
                [ReportFilterOperationType.EQUALS, t.filterOperationEquals],
                [ReportFilterOperationType.NOT_EQUALS, t.filterOperationNotEquals],
                [ReportFilterOperationType.STARTS_WITH, t.filterOperationStartsWith],
                [
                    ReportFilterOperationType.NOT_STARTS_WITH,
                    t.filterOperationNotStartsWith,
                ],
                [ReportFilterOperationType.ENDS_WITH, t.filterOperationEndsWith],
                [ReportFilterOperationType.NOT_ENDS_WITH, t.filterOperationNotEndsWith],
                [ReportFilterOperationType.CONTAINS, t.filterOperationContains],
                [ReportFilterOperationType.NOT_CONTAINS, t.filterOperationNotContains],
                [ReportFilterOperationType.ALL_IS_LESS, t.filterOperationAllIsLess],
                [ReportFilterOperationType.ALL_IS_MORE, t.filterOperationAllIsMore],
                [
                    ReportFilterOperationType.AT_LEAST_ONE_IS_LESS,
                    t.filterOperationAtLeastOneIsLess,
                ],
                [
                    ReportFilterOperationType.AT_LEAST_ONE_IS_MORE,
                    t.filterOperationAtLeastOneIsMore,
                ],
                [ReportFilterOperationType.IS_NULL, t.filterOperationIsNull],
                [ReportFilterOperationType.IS_NOT_NULL, t.filterOperationIsNotNull],
            ]);
        };
        _this.getOperationOptions = function () {
            var t = _this.props.t;
            return new Map([
                [ReportFilterOperationType.EQUALS, t.filterOperationEquals],
                [ReportFilterOperationType.NOT_EQUALS, t.filterOperationNotEquals],
                [ReportFilterOperationType.STARTS_WITH, t.filterOperationStartsWith],
                [
                    ReportFilterOperationType.NOT_STARTS_WITH,
                    t.filterOperationNotStartsWith,
                ],
                [ReportFilterOperationType.ENDS_WITH, t.filterOperationEndsWith],
                [ReportFilterOperationType.NOT_ENDS_WITH, t.filterOperationNotEndsWith],
                [ReportFilterOperationType.CONTAINS, t.filterOperationContains],
                [ReportFilterOperationType.NOT_CONTAINS, t.filterOperationNotContains],
                [ReportFilterOperationType.ALL_IS_LESS, t.filterOperationAllIsLess],
                [ReportFilterOperationType.ALL_IS_MORE, t.filterOperationAllIsMore],
                [
                    ReportFilterOperationType.AT_LEAST_ONE_IS_LESS,
                    t.filterOperationAtLeastOneIsLess,
                ],
                [
                    ReportFilterOperationType.AT_LEAST_ONE_IS_MORE,
                    t.filterOperationAtLeastOneIsMore,
                ],
            ]);
        };
        _this.onOperationSelected = function (selectedItem) {
            var _a = _this.props, filter = _a.filter, onFilterOptionSelected = _a.onFilterOptionSelected;
            onFilterOptionSelected({
                filter: filter,
                selectedItem: selectedItem,
                optionType: FilterOptionTypes.Operation,
            });
        };
        _this.onKeySelected = function (selectedItem) {
            var _a = _this.props, filter = _a.filter, onFilterOptionSelected = _a.onFilterOptionSelected;
            onFilterOptionSelected({
                filter: filter,
                selectedItem: selectedItem,
                optionType: FilterOptionTypes.Key,
            });
            if (filter.operation === ReportFilterOperationType.IS_NULL ||
                filter.operation === ReportFilterOperationType.IS_NOT_NULL) {
                _this.onFilterInputSingleKeyNullChanged();
            }
        };
        _this.onDateSelected = function (name, value) {
            var _a = _this.props, filter = _a.filter, onFilterInputChanged = _a.onFilterInputChanged;
            onFilterInputChanged({ filter: filter, name: name, value: value });
        };
        _this.onFilterInputChanged = function (event) {
            var _a = _this.props, filter = _a.filter, onFilterInputChanged = _a.onFilterInputChanged;
            var target = event.target;
            var name = target.name;
            var value = target.value;
            onFilterInputChanged({ filter: filter, name: name, value: value });
        };
        _this.onFilterInputSingleKeyNullChanged = function () {
            var _a = _this.props, filter = _a.filter, onFilterInputChanged = _a.onFilterInputChanged;
            onFilterInputChanged({ filter: filter, name: "null", value: "null" });
        };
        _this.generateReportRequestIfNeeded = function (prevProps, nextProps) {
            var prevFilter = prevProps && prevProps.filter;
            var nextFilter = nextProps && nextProps.filter;
            if (!nextFilter || !prevFilter || !nextFilter.filterType) {
                return;
            }
            if (nextFilter.filterType === FilterTypes.DateRanges) {
                if ((nextFilter.filterType === prevFilter.filterType &&
                    nextFilter.key === prevFilter.key &&
                    nextFilter.to === prevFilter.to &&
                    nextFilter.from === prevFilter.from) ||
                    !nextFilter.key ||
                    !nextFilter.from ||
                    !nextFilter.to) {
                    return;
                }
            }
            else if (nextFilter.filterType === FilterTypes.SingleKeys) {
                if (nextFilter.operation !== ReportFilterOperationType.IS_NULL &&
                    nextFilter.operation !== ReportFilterOperationType.IS_NOT_NULL) {
                    if ((nextFilter.filterType === prevFilter.filterType &&
                        nextFilter.operation === prevFilter.operation &&
                        nextFilter.key === prevFilter.key &&
                        nextFilter.values === prevFilter.values) ||
                        !nextFilter.operation ||
                        !nextFilter.key ||
                        !nextFilter.values) {
                        return;
                    }
                }
                else {
                    if ((nextFilter.filterType === prevFilter.filterType &&
                        nextFilter.operation === prevFilter.operation &&
                        nextFilter.key === prevFilter.key) ||
                        !nextFilter.operation ||
                        !nextFilter.key) {
                        return;
                    }
                }
            }
            else {
                if ((nextFilter.filterType === prevFilter.filterType &&
                    nextFilter.operation === prevFilter.operation &&
                    nextFilter.value === prevFilter.value &&
                    (nextFilter.keys && nextFilter.keys.length) ===
                        (prevFilter.keys && prevFilter.keys.length)) ||
                    !nextFilter.operation ||
                    !nextFilter.value ||
                    !nextFilter.keys ||
                    nextFilter.keys.length < 1) {
                    return;
                }
            }
            var onGenerateReportRequest = _this.props.onGenerateReportRequest;
            onGenerateReportRequest();
        };
        return _this;
    }
    FilterControl.prototype.componentDidUpdate = function (prevProps) {
        this.generateReportRequestIfNeeded(prevProps, this.props);
    };
    FilterControl.prototype.render = function () {
        var _a = this.props, filter = _a.filter, t = _a.t;
        return (React.createElement("div", { className: "rb-filter-control" },
            React.createElement("div", { style: { display: "flex", columnGap: 10 } },
                React.createElement("div", { className: "rb-filter-dropdown" },
                    React.createElement(DropDownList, { list: this.getFilterTypeOptions(), defaultLabel: t.filterTypePlaceholder, selected: filter.filterType, itemSelectedCallback: this.onTypeSelected })),
                this.renderRemoveFilterButton()),
            React.createElement("div", { style: { marginTop: 15 } }, this.renderOperationsFilter()),
            this.renderSingleValuesInput(),
            this.renderKeyFilter(),
            this.renderDateRangesFilter(),
            this.renderSingleKeysInput()));
    };
    FilterControl.prototype.renderRemoveFilterButton = function () {
        return (React.createElement("span", { className: "rb-btn-filter-remove", onClick: this.onFilterRemoveClicked },
            React.createElement("i", null,
                React.createElement(FontAwesomeIcon, { icon: faTrashAlt }))));
    };
    FilterControl.prototype.renderOperationsFilter = function () {
        var _a = this.props, filter = _a.filter, t = _a.t;
        if (!filter)
            return null;
        if (filter.filterType === FilterTypes.SingleKeys) {
            return (React.createElement("div", { className: "rb-filter-dropdown", style: { marginBottom: 15 } },
                React.createElement(DropDownList, { list: this.getSingleKeyOperationOptions(), defaultLabel: t.filterOperationPlaceholder, selected: filter.operation, itemSelectedCallback: this.onOperationSelected })));
        }
        if (filter.filterType === FilterTypes.SingleValues) {
            return (React.createElement("div", { className: "rb-filter-dropdown", style: { marginBottom: 15 } },
                React.createElement(DropDownList, { list: this.getOperationOptions(), defaultLabel: t.filterOperationPlaceholder, selected: filter.operation, itemSelectedCallback: this.onOperationSelected })));
        }
    };
    FilterControl.prototype.renderKeyFilter = function () {
        var _a = this.props, filter = _a.filter, dimensions = _a.dimensions, t = _a.t;
        var isMulti = false;
        var selected = filter.key;
        var placeholder = t.filterSingleKeyPlaceholder;
        if (filter.filterType === FilterTypes.SingleValues) {
            isMulti = true;
            selected = filter.keys;
            placeholder = t.filterSingleValueKeysPlaceholder;
        }
        return (React.createElement("div", { className: classnames({
                "rb-filter-dropdown": true,
                "rb-filter-multi": isMulti,
            }) },
            React.createElement(DropDownListWithSearch, { list: dimensions, hideOptions: true, placeholder: placeholder, selected: selected, disabled: !filter.filterType, isClearable: false, isMulti: isMulti, optionSelectedCallback: this.onKeySelected })));
    };
    FilterControl.prototype.renderSingleKeysInput = function () {
        var _a = this.props, filter = _a.filter, t = _a.t;
        if (filter.filterType !== FilterTypes.SingleKeys) {
            return null;
        }
        if (filter.operation === ReportFilterOperationType.IS_NULL ||
            filter.operation === ReportFilterOperationType.IS_NOT_NULL) {
            return null;
        }
        return (React.createElement("div", { className: "rb-filter-values" },
            React.createElement("p", null, t.filterValuesDescription),
            React.createElement("p", null,
                t.filterValuesExample,
                ": ",
                React.createElement("b", null, "1;2;3")),
            React.createElement("input", { id: "values", className: "rb-input", name: "values", type: "text", value: filter.values ? filter.values : "", disabled: !filter.operation, onChange: this.onFilterInputChanged })));
    };
    FilterControl.prototype.renderSingleValuesInput = function () {
        var _a = this.props, filter = _a.filter, t = _a.t;
        if (filter.filterType !== FilterTypes.SingleValues) {
            return null;
        }
        return (React.createElement("div", { className: "rb-filter-value" },
            React.createElement("input", { id: "values", className: "rb-input", name: "value", type: "text", placeholder: t.filterSingleValuePlaceholder, value: filter.value ? filter.value : "", disabled: !filter.operation, onChange: this.onFilterInputChanged })));
    };
    FilterControl.prototype.renderDateRangesFilter = function () {
        var _a = this.props, filter = _a.filter, t = _a.t;
        if (!filter || filter.filterType !== FilterTypes.DateRanges) {
            return null;
        }
        return (React.createElement("div", { className: "rb-date-ranges-filter" },
            React.createElement("div", null,
                React.createElement("label", null, t.filterFromLabel),
                React.createElement(CustomDatePicker, { name: "from", startDate: filter.from, maxDate: filter.to, onDateInputChangedCallback: this.onFilterInputChanged, onDateSelectedCallback: this.onDateSelected })),
            React.createElement("div", null,
                React.createElement("label", null, t.filterToLabel),
                React.createElement(CustomDatePicker, { name: "to", startDate: filter.to, minDate: filter.from, onDateInputChangedCallback: this.onFilterInputChanged, onDateSelectedCallback: this.onDateSelected }))));
    };
    return FilterControl;
}(React.PureComponent));
export { FilterControl };
